module.exports = __webpack_public_path__ + "img/light-f-fm-Path 47@3x.ad67b01c.png";